// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"271d78d9","787":"0122b0e5"}[chunkId] + ".chunk.js";
};